import { AccordionDetails } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Accordion, { AccordionSummary } from "@rui/Accordion";
import { Row } from "@rui/Stack";

export const NoteSectionHeaderTitleAndActionsContainer = styled(Row)(
  ({ theme }) => ({
    gap: theme.spacing(1),
    alignItems: "center",
    flex: 1,
    justifyContent: "space-between",
    [theme.breakpoints.up("mobile")]: {
      justifyContent: "flex-start",
    },
  })
);

export const NoteCardAccordion = styled(Accordion)(({ theme }) => ({
  border: "1px solid",
  borderRadius: theme.corners.base,
  borderColor: theme.palette.shades.neutral[100],
  marginTop: theme.spacing(2),

  "& .note-section__action__container": {
    opacity: 0,
    pointerEvents: "none",
    transition: "all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  },
  "&.Mui-expanded": {
    "& .note-section__action__container": {
      opacity: 1,
      pointerEvents: "auto",
    },
  },
  "&.disabled": {
    backgroundColor: theme.palette.shades.neutral[50],
  },
  "&.editing": {
    borderColor: "transparent",
    "&:not(:last-of-type)": {
      border: "none",
      "&:not(.disabled)": {
        borderBottom: "1px solid",
        borderRadius: 0,
        borderColor: theme.palette.shades.neutral[100],
        paddingBottom: theme.spacing(1.5),
      },
      [theme.breakpoints.up("mobile")]: {
        paddingBottom: theme.spacing(1),
      },
    },
    "& .icon-heading__icon": {
      display: "none",
    },
    "&:not(.disabled)": {
      "& .MuiAccordionDetails-root": {
        padding: theme.spacing(0, 1.5, 1),
      },
      "& .MuiAccordionSummary-root": {
        minHeight: "30px",
      },
    },
  },
  [theme.breakpoints.up("mobile")]: {
    paddingTop: theme.spacing(1),
    "& .note-section__action": {
      opacity: 0, // uses opacity so the height is accounted for when not visible
      pointerEvents: "none",
      transition: "opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
    "&:hover": {
      "& .note-section__action": {
        opacity: 1,
        pointerEvents: "auto",
      },
    },
  },
}));

export const NoteCardAccordionSummary = styled(AccordionSummary)(
  ({ theme }) => ({
    minHeight: "56px",
    padding: theme.spacing(0, 2),
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up("mobile")]: {
      padding: theme.spacing(0, 1.5),
      minHeight: "40px",
      "& .MuiAccordionSummary-expandIconWrapper": {
        display: "none",
      },
    },
  })
);

export const NoteCardAccordionDetails = styled(AccordionDetails)(
  ({ theme }) => ({
    padding: theme.spacing(0, 2, 2),
    "& .note-sub-section--summary": {
      padding: theme.spacing(0, 1),
    },
    [theme.breakpoints.up("mobile")]: {
      padding: theme.spacing(0, 1.5, 2),
      "& .note-sub-section--summary": {
        padding: theme.spacing(1, 1, 0),
      },
    },
  })
);
